import { ButtonBase, Typography } from '@material-ui/core';
import { ColorDynamic, Stack } from '@superdispatch/ui';
import { RobotIcon } from 'shared/icons/RobotIcon';
import { ResponsiveTooltip } from 'shared/ui/ResponsiveTooltip';
import styled from 'styled-components';

const Badge = styled(ButtonBase)`
  gap: 4px;
  height: 20px;
  padding: 0 7px 0 5px;
  border-radius: 10px;
  background-color: ${ColorDynamic.Purple50};
  color: ${ColorDynamic.Purple500};
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  cursor: help;

  & .MuiSvgIcon-root {
    font-size: 13px;
  }
`;

export function ImportedWithAIBadge() {
  return (
    <ResponsiveTooltip
      placement="bottom-start"
      title={
        <Stack space="xxsmall">
          <Typography variant="h6" color="inherit">
            Imported with AI
          </Typography>
          <Typography color="inherit">
            Load details were extracted from this file by AI and may contain
            mistakes. Review VINs, addresses and dates before dispatching.
          </Typography>
        </Stack>
      }
    >
      <Badge aria-label="Imported with AI">
        <RobotIcon />
        AI
      </Badge>
    </ResponsiveTooltip>
  );
}
